/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_NewInputs */

const en_recipe_new = /** @type {(inputs: Recipe_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a recipe`)
};

const de_recipe_new = /** @type {(inputs: Recipe_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept schreiben`)
};

/**
* | output |
* | --- |
* | "Write a recipe" |
*
* @param {Recipe_NewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_new = /** @type {((inputs?: Recipe_NewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_NewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_new(inputs)
	return en_recipe_new(inputs)
});